(() => {
  if (window.__PCF_INIT__) return
  window.__PCF_INIT__ = true

  document.addEventListener(
    'submit',
    (e) => {
      const form = e.target
      if (!form || typeof form.querySelector !== 'function') return

      const field = form.querySelector('input[name="properties[__customization_variant]"]')
      if (!field) return

      if (!field.value || field.value === 'undefined') {
        field.parentNode && field.parentNode.removeChild(field)
      }
    },
    true,
  )
})()